import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/AuthForms.css';

function RobloxLinkCallback() {
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    handleCallback();
  }, []);

  async function handleCallback() {
    const params = new URLSearchParams(window.location.search);
    const success = params.get('link_success');
    const error = params.get('link_error');
    const username = params.get('username');

    if (success === 'true') {
      setStatus('success');
      setMessage(`Successfully linked Roblox account${username ? ` @${username}` : ''}! Welcome to DripBattle!`);

      // Refresh user data
      await checkAuth();

      // Redirect to home after 2 seconds
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    } else if (error) {
      setStatus('error');
      setMessage(`Linking failed: ${decodeURIComponent(error)}`);
    } else {
      setStatus('error');
      setMessage('Invalid callback');
    }
  }

  return (
    <div className="verification-container">
      <div className="verification-card">
        {status === 'loading' && (
          <>
            <div className="spinner"></div>
            <p>Processing Roblox link...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="success-icon">✅</div>
            <h2>Roblox Account Linked!</h2>
            <p>{message}</p>
            <p>Redirecting...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="error-icon">❌</div>
            <h2>Linking Failed</h2>
            <p>{message}</p>
            <button onClick={() => (window.location.href = '/')} className="btn-primary">
              Go Home
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default RobloxLinkCallback;
